import React from 'react';
import Tetris from './components/Tetris';
import logo from './logo.svg';
import './App.css';

function App() {
  return (
    <div className="">
      <Tetris />
    </div>
  );
}

export default App;
